import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Platform } from 'data/terra/Platform';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_PLATFORMS = 'FETCH_PLATFORMS';

export interface FetchPlatformsAction {
  type: typeof FETCH_PLATFORMS;
  platforms: Platform[];
  error?: string;
}

export const fetchPlatforms = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.platform.fetchPlatforms();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_PLATFORMS,
      platforms: result.get()!.data,
    } as FetchPlatformsAction);
  } else {
    dispatch({
      type: FETCH_PLATFORMS,
      platforms: [],
      error: result.exception().message,
    } as FetchPlatformsAction);
  }

  return result;
};

export const fetchPlatformsDelegate: DelegateMapEntry<
  FetchPlatformsAction,
  CommonState
> = {
  [FETCH_PLATFORMS]: (
    state: CommonState,
    action: FetchPlatformsAction
  ): CommonState => {
    return {
      ...state,
      platforms: action.platforms,
      platformError: action.error,
    };
  },
};
